import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { DataGrid } from "@mui/x-data-grid";
import { makeStyles } from "@material-ui/styles";
import PulseLoader from "react-spinners/PulseLoader"
import { change_in_topic_risk_score } from "../../services/CertificationsAPI";

const theme = localStorage.getItem("brandColor");

const useStyles = makeStyles({
    root: {
        "& .super-app-theme--cell": {
        backgroundColor: "rgba(224, 183, 60, 0.55)",
        color: "#1a3e72",
        fontWeight: "600",
        },
        "& .super-app.negative": {
        backgroundColor: "rgba(157, 255, 118, 0.49)",
        color: "#1a3e72",
        fontWeight: "600",
        },
        "& .super-app.positive": {      
        border: "1px solid #ff8c24",
        color: "#1a3e72",
        fontWeight: "600",
        },
        "& .super-app-theme--header": {
        color: "#FFFFFF",
        fontWeight: "600",
        },
    },
});

const StyledButton = styled.button`
    background: ${theme};
    width: 200px;
    border-radius: 30px;
    height: 45px;
    text-align: center;
    color: white;
    font-size: 16px !important;
    font-weight: 500;
    border-color: none;
    border: none;
    margin-top: 25px;
    padding: 5px 10px;
`;

const ChangeInTopicRiskScore = () => {
    const classes = useStyles();    
    const history = useHistory()    
    let [loading, setloading] = useState(true)
    const [changeInTopicRiskScore, setChangeInTopicRiskScore] = useState([]);        

    useEffect(() => {       
        prepareInitialData() 
    }, []);

    const prepareInitialData = async () => {
        let result = await change_in_topic_risk_score({customer_id: localStorage.getItem('customerid')})
        if(result){            
            setloading(false);
            console.log(result.data.change_in_topic_risk_score)
            setChangeInTopicRiskScore(result.data.change_in_topic_risk_score);
        }
    }

    const changeInTopicRiskScoreColumns = [
        {
            field: "cuzdesc_topicdesc",
            headerName: "Topic",
            flex: 1,
            align: "left",
            headerAlign: "center",
            headerClassName: "super-app-theme--header",
            renderCell: (params) => (
                <div
                style={{
                    whiteSpace: 'normal',
                    wordBreak: 'break-word',
                    lineHeight: '1.4',
                    overflowWrap: 'anywhere',
                }}
                >
                {params.value}
                </div>
            ),
        },
        {
            field: "locationdesc",
            headerName: "Location",
            flex: 0.5,
            align: "left",
            headerAlign: "center",
            headerClassName: "super-app-theme--header"          
        },       
        {
            field: "latestperiod",
            headerName: "Latest Period",
            // flex: 1,
            align: "center",
            headerAlign: "center",
            headerClassName: "super-app-theme--header"          
        },
        {
            field: "latestscore",
            headerName: "Latest Score",
            // flex: 1,
            align: "center",
            headerAlign: "center",
            headerClassName: "super-app-theme--header"          
        },
        {
            field: "pctchange",
            headerName: "% Increase (Decrease)",
            // flex: 1,
            align: "center",            
            renderCell: (params) => {
                return (                    
                    <div>                        
                        {
                            !isNaN(+params.value)                        
                            ? (+params.value < 0) ? `(${Math.abs(params.value)})` : `${params.value}`
                            : (params.value === "nolatest" || (params.row.latestscore === "0" && params.row.firstscore === "0")) ? 'None' : `${params.value}`
                        }                      
                    </div>
                );
            },
            headerAlign: "center",
            headerClassName: "super-app-theme--header"          
        },
        {
            field: "riskchange",
            headerName: "Risk Change",
            // flex: 1,
            align: "left",
            renderCell: (params) => {       
                let pctchange = params.row.pctchange                         
                let latestscore = params.row.latestscore                         
                return (
                    <div>
                        {
                            (!isNaN(pctchange) && (pctchange < 0)) && (+latestscore === 0)
                            ? "Removed"
                            : params.value
                        }
                    </div>
                );
            },
            headerAlign: "center",
            headerClassName: "super-app-theme--header"          
        }        
    ];
        
    return (
        loading ? 
        ( 
            <div style={{height: 'calc(100vh - 66px)'}} className="d-flex justify-content-center align-items-center">
                <PulseLoader size={10} color={theme} />
            </div> 
        ) 
        : 
        (
            <>
                <div className="container">
                    <div className="text-center">
                        <StyledButton
                            onClick={() => {
                                history.push("/certifications");
                            }}
                        >
                        Exit
                        </StyledButton>
                    </div>                    
                    <div className="mt-4">
                        <h4 className="text-center">Change in Topic Risk Score</h4>
                        <div style={{ height: "auto", width: "100%", margin: 'auto' }} className={classes.root}>
                            <DataGrid
                                sx={{
                                    ".MuiDataGrid-columnHeaders": {
                                        backgroundColor: theme,
                                    },
                                    "&.MuiDataGrid-root": {
                                        border: "none",
                                    },
                                }}
                                getRowId={(r) => r.id}
                                autoHeight      
                                onRowClick={(params) => {                                    
                                    history.push(`/topic_risk_score_details/`, params.row);
                                }}                       
                                rows={changeInTopicRiskScore}                                
                                id="_id"                     
                                columns={changeInTopicRiskScoreColumns} 
                                hideFooterPagination={true}                       
                            />
                        </div>
                    </div>                               
                </div>
            </>
        )
    )
}


export default ChangeInTopicRiskScore